"use strict";
var window = require("global");

var Native = require("./SoundNative");
var AudioTag = require("./SoundAudioTag");
var WebAudio = require("./SoundWebAudio");

var Sound = AudioTag;

if (haveNativeAudioPlugin()){
	Sound = Native;
} else if(haveAudioContext() && (!window.require)){
	Sound = WebAudio;
}

module.exports = Sound;

function haveAudioContext(){
	return window.AudioContext;
}

function haveNativeAudioPlugin(){
	return window.plugins && window.plugins.NativeAudio;
}